import styled from 'styled-components';

export const LoaderBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9998;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${p => p.theme.loader.backdrop};
  backdrop-filter: blur(5px);
`;

export const LoaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  background-color: ${p => p.theme.colors.main.white};
  box-shadow: ${p => p.theme.loader.wrapShadow};
  border: ${p => p.theme.loader.wrapBorder};
  border-radius: 30px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -50px;
  margin-top: -50px;
`;
